var img = "data:image/svg+xml,%3csvg width='7' height='10' viewBox='0 0 7 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M1.19734 0L6.25 5L1.19734 10L0 8.81023L3.85036 5L0 1.18977L1.19734 0Z' fill='%23323130'/%3e%3c/svg%3e";

export { img as default };
